<div class="error-container">
  <app-error-box [errorText]="errorText"></app-error-box>
</div>
